import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';

const AuthSequencingCardFooter = ({
  locationId,
  productId,
  getCardHasChanges,
  handleCardChange,
  cardRefs,
  isProcessing,
  onCardSave,
  onCardCancel,
}) => {
  const cardHasChanges = getCardHasChanges(locationId, productId);
  const isDisabled = !cardHasChanges || isProcessing;

  const handleSave = () => {
    if (onCardSave) {
      onCardSave(locationId, productId);
    }
  };

  const handleCancel = () => {
    if (onCardCancel) {
      onCardCancel(locationId, productId);
      return;
    }

    // Fallback: Reset the card to its initial state if no onCardCancel handler provided
    const cardKey = `${locationId}-${productId}`;
    const cardRef = cardRefs.current[cardKey];
    if (cardRef?.current?.reset) {
      cardRef.current.reset();
    }

    // Reset changes tracking
    handleCardChange(locationId, productId, false);
  };

  return (
    <>
      <Button
        color="primary"
        disabled={isDisabled}
        onClick={handleSave}
        sx={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
        variant="outlined"
      >
        Save Sequence
      </Button>
      <Button
        color="primary"
        disabled={isDisabled}
        onClick={handleCancel}
        sx={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
        variant="outlined"
      >
        Cancel
      </Button>
    </>
  );
};

AuthSequencingCardFooter.propTypes = {
  cardRefs: PropTypes.shape({
    current: PropTypes.shape({}),
  }).isRequired,
  getCardHasChanges: PropTypes.func.isRequired,
  handleCardChange: PropTypes.func.isRequired,
  isProcessing: PropTypes.bool,
  locationId: PropTypes.number.isRequired,
  onCardCancel: PropTypes.func,
  onCardSave: PropTypes.func,
  productId: PropTypes.number.isRequired,
};

AuthSequencingCardFooter.defaultProps = {
  isProcessing: false,
  onCardCancel: null,
  onCardSave: null,
};

export default AuthSequencingCardFooter;
